export function revisionText(value) {
  if (storedSettingsRevision(value) === null) {
    return "not configured";
  }
  return String(value);
}

export function storedSettingsRevision(value) {
  if (typeof value !== "number" || !Number.isSafeInteger(value) || value < 0) {
    return null;
  }
  return value;
}

export function schemaVersionText(settings) {
  return revisionText(settings && settings.schema_version);
}

export function specRevisionText(settings) {
  const value = settings && settings.spec_revision;
  if (typeof value !== "string" || value.length === 0) {
    return "not configured";
  }
  return value;
}

export function botTypeText(settings) {
  const value = settings && settings.bot_type;
  if (typeof value !== "string" || value.length === 0) {
    return "not configured";
  }
  return value;
}

export function userIdText(settings) {
  const value = settings && settings.user_id;
  if (typeof value !== "string" || value.length === 0) {
    return "not configured";
  }
  return value;
}

export function copyRevisionSiblings(settings, source) {
  const next = { ...(settings || {}) };
  const revision = storedSettingsRevision(source && source.settings_revision);
  if (revision !== null) {
    next.settings_revision = revision;
  }
  const policyRevision = storedSettingsRevision(source && source.dispatch_policy_revision);
  if (policyRevision !== null) {
    next.dispatch_policy_revision = policyRevision;
  }
  return next;
}
